import * as React from 'react';
import { Notify } from '@shared/ui-native/Notify';
import { cs } from '@shared/utils/utils-classname';
import './InlineEdit.scss';
import { Ajax2 } from '@shared/Ajax';

export class InlineEdit extends React.Component<
    {
        text: string;
        url: string;
        param?: string;
        doSave?: (text: string) => Promise<any>;
        onSaveSuccess?: Function;
        onExit?: Function;
        onStartEdit?: Function;
        autoClose?: boolean;
        disabled?: boolean;
        requestParams?: object;
        minLength?: number;
        children?: React.ReactNode;
    },
    {}
> {
    static defaultProps = {
        // default props
        param: 'value',
        minLength: 1,
    };

    state = {
        id: 0, // id
        edit: false,
        isLoading: false,
        text: this.props.text,
        hasChanged: false,
        inputStyle: {
            minWidth: 200,
            fontSize: 13,
        },
    };

    elems: {
        form?: HTMLFormElement;
        input?: HTMLInputElement;
        span?: HTMLSpanElement;
    } = {};

    componentDidMount() {
        if (this.refs.span) {
            const $span = $(this.refs.span);
            this.state.inputStyle = {
                minWidth: this.elems.span.offsetWidth + 16,
                fontSize: parseInt($span.css('font-size')),
            };
        }

        if (this.props.autoClose) {
            $(window).on(`click.inlineedit${this.state.id}`, e => {
                // close/dismiss edit mode on outside click
                if (this.state.edit) {
                    this.setState({ edit: false, hasChanged: false });
                }
            });
        }
    }

    componentWillUnmount() {
        if (this.props.autoClose) {
            $(window).off(`click.inlineedit${this.state.id}`);
        }
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.text != this.props.text) {
            this.setState({ text: this.props.text });
        }
    }

    handleSave() {
        const text = this.elems.input.value;

        // check if input changed or empty
        // but only if there are no react children
        if ((!this.props.children && text == this.state.text) || text.length < this.props.minLength) {
            console.log('Inline edit - value unchanged');
            this.setState({
                edit: false,
            });
            return true;
        }

        this.setState({ isLoading: true });

        let promise: Promise<any> = null;
        if (typeof this.props.doSave === 'function') {
            promise = this.props.doSave(text);
        } else {
            promise = Ajax2({
                url: this.props.url,
                method: 'POST',
                data: {
                    [this.props.param]: text,
                    ...(this.props.requestParams || {}),
                },
            });
        }

        promise
            .then(resp => {
                this.setState({
                    edit: false,
                    isLoading: false,
                    text,
                });
                this.props.onExit();

                if (resp.status) {
                    Notify.success();
                    if (typeof this.props.onSaveSuccess === 'function') {
                        this.props.onSaveSuccess(text, resp);
                    }
                }
            })
            .catch(e => {
                if (e?.response?.status === 409) {
                    Notify.error(kuura.getMessage('js_files.msg.error.validation_identical_file'));
                } else {
                    Notify.error();
                }
                this.setState({
                    edit: false,
                    isLoading: false,
                });
                this.props.onExit();
            });
    }

    handleEdit() {
        this.setState({ edit: true });
        if (this.props.onStartEdit) {
            this.props.onStartEdit();
        }
    }

    render() {
        const wrapperClasses = cs({
            'inline-edit--wrapper': true,
            edit: this.state.edit,
            'has-children': !!this.props.children,
        });

        return (
            <div>
                <span className={wrapperClasses} onClick={e => e.stopPropagation()}>
                    <form ref={e => (this.elems.form = e)} action='' encType='multipart/form-data' method='post' onChange={this.onFormChange} onSubmit={e => e.preventDefault()}>
                        {this.renderInput()}
                        {this.renderButtons()}
                    </form>
                </span>
            </div>
        );
    }

    renderInput() {
        const { edit, isLoading, text } = this.state;

        if (edit) {
            const input = (
                <input defaultValue={text} name={this.props.param} disabled={isLoading} ref={e => (this.elems.input = e)} style={this.state.inputStyle} autoFocus={true} />
            );
            if (this.props.children) {
                return (
                    <span>
                        {input}
                        <br />
                        {this.props.children}
                    </span>
                );
            } else {
                return input;
            }
        } else {
            return (
                <span ref={e => (this.elems.span = e)} className='inline-edit--text'>
                    {text}
                </span>
            );
        }
    }

    renderButtons() {
        if (this.props.disabled) {
            return;
        }
        if (this.state.edit) {
            return (
                <span className='btn-group'>
                    <button
                        onClick={() => {
                            this.setState({ edit: false, hasChanged: false });
                            if (this.props.onExit) this.props.onExit();
                        }}
                        disabled={this.state.isLoading}
                    >
                        <i className='iki iki-cross'></i>
                    </button>
                    <button
                        className={cs({ loading: this.state.isLoading, 'ik-button-primary': true })}
                        onClick={this.handleSave.bind(this)}
                        disabled={this.state.isLoading || !this.state.hasChanged}
                    >
                        <i className='iconf-check'></i> <span>{kuura.getMessage('general.save')}</span>
                    </button>
                </span>
            );
        } else {
            return (
                <button onClick={this.handleEdit.bind(this)} className='ik-button-secondary--subtle inline-edit--edit-btn'>
                    <i className='iki iki-edit'></i>
                </button>
            );
        }
    }

    setText = (text: string) => {
        this.setState({ text });
        this.elems.input.value = text;
    };

    onFormChange = evt => {
        this.setState({
            hasChanged: true,
        });
    };
}
